import { useSelector } from 'react-redux';

export enum DataExportPermissionMode {
  Disabled = 0,
  DirectToMember = 1,
  RouteToOwner = 2,
}

export const useCanShowDataExport = (): boolean => {
  const { dataExportPermission } = useSelector((state: any) => ({
    role: state.home?.role,
    dataExportPermission: state.home?.dataExportPermission,
  }));

  return dataExportPermission !== DataExportPermissionMode.Disabled;
};

export const useShouldRouteDataExportToOwner = (): boolean => {
  const { dataExportPermission } = useSelector((state: any) => ({
    role: state.home?.role,
    dataExportPermission: state.home?.dataExportPermission,
  }));

  return dataExportPermission === DataExportPermissionMode.RouteToOwner;
};
